import { appDataName } from "../../app/dataTypes";
import { RootState } from "../../app/rootReducer";
import { resourceSliceName } from "./dataTypes";
import { resourceAdapter } from "./resourceAdapter";

const selectSliceState = (state: RootState) => state[appDataName][resourceSliceName];

const adapterSelectors = resourceAdapter.getSelectors(selectSliceState);

export const selectErrorMessage = (state: RootState) => selectSliceState(state).errorMessage;

export const selectRequestState = (state: RootState) => selectSliceState(state).requestState;

export const selectCount = (state: RootState) => selectSliceState(state).count;

export const selectResourceEntities = adapterSelectors.selectEntities;
export const selectResources = adapterSelectors.selectAll;
export const selectResource =
  (id = "") =>
  (state: RootState) =>
    adapterSelectors.selectById(state, id);
